import React from 'react';
import PropTypes from 'prop-types';
import Overlay from 'components/Overlay';

/**
 * Success Component
 * @param {Object} theme                - Theme override sent through CSS Themr
 * @param {Object} sharedTheme          - Theme override sent through CSS Themr for shared styling
 * @param {Node} children               - any additional items: button, image, text, etc.
 * @param {Node} innerContainerChildren - any additional items: button, image, text, etc.
 * @param {Boolean} rendered            - should this item render?
 * @returns {Component}                 - React Component
 */

const Success = ({
  backgroundClass,
  backgroundUrl,
  children,
  innerContainerChildren,
  innerContainerChildrenParams,
  rendered,
  sharedTheme,
  theme,
}) => (
  <Overlay
    backgroundClass={backgroundClass}
    backgroundUrl={backgroundUrl}
    innerContainerChildren={innerContainerChildren}
    innerContainerChildrenParams={innerContainerChildrenParams}
    rendered={rendered}
    sharedTheme={sharedTheme}
    theme={theme}
  >
    {children}
  </Overlay>
);

Success.defaultProps = {
  backgroundClass: '',
  backgroundUrl: null,
  children: [],
  innerContainerChildren: () => {},
  innerContainerChildrenParams: {},
  rendered: false,
  sharedTheme: {},
  theme: {},
};

Success.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  backgroundClass: PropTypes.string,
  backgroundUrl: PropTypes.string,
  innerContainerChildren: PropTypes.func,
  innerContainerChildrenParams: PropTypes.shape({}),
  rendered: PropTypes.bool,
  sharedTheme: PropTypes.shape({}),
  theme: PropTypes.shape({}),
};

export default Success;
